export const SALARY_REPORT_STATE = {
    report_month: ""
}